var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoClassMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9219 16.3281C23.5059 16.3281 24 16.8223 24 17.4062C24 18.0352 23.5059 18.4844 22.9219 18.4844H4.54883L7.87305 22.0781C8.27734 22.5273 8.27734 23.2012 7.82812 23.6055C7.60352 23.7852 7.33398 23.875 7.10938 23.875C6.79492 23.875 6.52539 23.7852 6.30078 23.5605L1.26953 18.1699C0.865234 17.7656 0.865234 17.0918 1.26953 16.6875L6.30078 11.2969C6.70508 10.8477 7.37891 10.8477 7.82812 11.252C8.27734 11.6562 8.27734 12.3301 7.87305 12.7793L4.54883 16.3281H22.9219ZM2.07812 8.42188C1.44922 8.42188 1 7.97266 1 7.34375C1 6.75977 1.44922 6.26562 2.07812 6.26562H20.4062L17.082 2.7168C16.6777 2.26758 16.6777 1.59375 17.127 1.18945C17.3516 1.00977 17.6211 0.875 17.8906 0.875C18.1602 0.875 18.4297 1.00977 18.6543 1.23438L23.6855 6.625C24.0898 7.0293 24.0898 7.70312 23.6855 8.10742L18.6543 13.498C18.25 13.9473 17.5762 13.9473 17.127 13.543C16.6777 13.1387 16.6777 12.4648 17.082 12.0156L20.4062 8.42188H2.07812Z",
    fill: "#7468DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoClassMember);
export default __webpack_public_path__ + "static/media/noClassMember.519d47744336f6d11af1679eaebedf4e.svg";
export { ForwardRef as ReactComponent };